import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './Global/store'

import { createI18n } from 'vue-i18n'
import activeLocales from '../public/locales/activeLocales.json'

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { createAuth0 } from '@auth0/auth0-vue'

library.add(fas, far)

const messages = {}

activeLocales.forEach((locale) => {
  try {
    const file = require(`../public/locales/${locale}.json`)
    if (locale === 'en-US') {
      messages.en = file
    } else {
      messages[locale] = file
    }
  } catch (e) {
    // Ignore file
  }
})

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  messages
})

const app = createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(store)
  .use(router)
  .use(i18n)
  .use(ElementPlus)
  .component('font-awesome-icon', FontAwesomeIcon)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

if (!window.location.pathname.includes('client')) {
  app.use(
    createAuth0({
      domain: 'login.telestream.net',
      clientId: 'MTpxGgUXrMZYHiCQyr9EsLQwsnigCuPF',
      authorizationParams: {
        audience: 'https://wirecastevents',
        scope: 'profile email read:messages',
        redirect_uri: `${window.location.origin}/billing/authenticate`
      }
    })
  )
}

app.mount('#app')
